import { LicenseInfo } from '@mui/x-license-pro';

export const registerMuiLicense = () => {
  LicenseInfo.setLicenseKey(
    'd8905914c45b2e65567b1f1ff0a264c1Tz0xMDA4OTYsRT0xNzYxODE4OTE1MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
  );
};
